export const ehrUsernameLabel = (ehr?: string | null): string => {
  const vendor = ehr?.trim();
  return vendor ? `${vendor} username` : 'EHR username';
};
